import { Injectable } from '@angular/core';
import {TranslateLoader} from '@ngx-translate/core';
import {HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NabelTranslateService implements TranslateLoader {

  constructor(private http: HttpClient) { }

  getTranslation(lang: string): Observable<any> {
    const contentHeader = new HttpHeaders({
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': 'application/json'
    });

    return new Observable(observer => {
      let url;
      // 言語ファイルの格納先を指定
      if (!environment.production) {
        // テスト環境用
        //url = 'https://storage.googleapis.com/cubelink_staticfiles/langtest/lang_main_';
        url = 'https://storage.googleapis.com/dev-farm-manager-proto_staticfiles/langtest/lang_main_';
      } else {
        // 本番環境用
        //url = 'https://storage.googleapis.com/cubelink_staticfiles/lang/lang_main_';
        url = 'https://storage.googleapis.com/farm-manager-proto_staticfiles/lang/lang_main_';
      }
      this.http.get(url + lang + '.json',
        { headers: contentHeader }).subscribe(
        (res) => {
          observer.next(res);
          observer.complete();
        },
        (error: HttpErrorResponse) => {
          observer.next('');
          observer.complete();
        }
      );
    });
  }
}
